// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"267":"b303d850","307":"3afaec28","313":"4011db5e","360":"c87d3291","606":"fd3fe89e","700":"fd3fe89e","725":"fd3fe89e","966":"846e7d63"}[chunkId] + ".css";
};